module.exports = __webpack_public_path__ + "static/media/calculator_mockup.f027a93f.png";